import { render, staticRenderFns } from "./ManageCase.vue?vue&type=template&id=b4431abc"
import script from "./ManageCase.vue?vue&type=script&lang=js"
export * from "./ManageCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports